<template>
  <div>
    <gl-header icon-name="gr-list" title="Latest transactions" />
    <home-transactions-table />
  </div>
</template>

<script>
import GlHeader from '@gl/GlHeader'
import HomeTransactionsTable from './components/HomeTransactionsTable'

export default {
  name: 'HomeTransactions',
  components: { HomeTransactionsTable, GlHeader },
}
</script>
